import { StencilCDNImage } from '@/components/Common/StencilImage'
import classNames from 'classnames'

export default function ActionButton({ data }) {
  return (
    <button
      onClick={() => {
        if (data?.onClick) {
          data.onClick()
        }
      }}
      className={classNames(
        'flex w-full items-center justify-end gap-x-0.5',
        data?.className,
      )}
    >
      {data?.title && (
        <div title={data?.tooltipTitle || data?.title}>{data.title}</div>
      )}
      {data?.image_url && (
        <StencilCDNImage src={data.image_url} width={16} height={16} />
      )}
      {data.children}
    </button>
  )
}
